import { useState } from "react";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import Menu from "../assets/menu.svg";
import "./Nav.scss";

const Nav = () => {
  const [menu, setMenu] = useState(false);
  const location = useLocation();

  return (
    <nav className="navigation">
      <img
        className="moveInLeft"
        src={Menu}
        alt="Menu Burger"
        onClick={() => setMenu(!menu)}
      />
      {
        menu &&
          (location.pathname === "/contact" ? (
            <Link to="/">
              <span>Home</span>
            </Link>
          ) : (
            <Link to="/contact">
              <span>Contact</span>
            </Link>
          ))
        // <span>{location.pathname === "/contact" ? "Home" : "Contact Us"}</span>
      }
    </nav>
  );
};

export default Nav;
